import React, { ReactElement } from 'react'
import { GetStaticProps } from 'next'
import { CourseConfigType } from 'common/src/courseConfig'
import { SplashPage } from '@/components/static/SplashPage/SplashPage'
import {
    fetchSplashPageProps,
    SplashPageProps,
} from '@/components/sharedFetchStaticProps/fetchSplashPageProps'
import { PageSeo } from '@/components/NextSeo/PageSeo'
import { UiLayoutConstant } from '@/globals/uiLayoutConstant'
import {
    ACTUARY_SITE_DESCRIPTION,
    ACTUARY_SITE_TITLE,
} from '@/components/NextSeo/seoConfig'
export const getStaticProps = (async (_context) => {
    const response = await fetchSplashPageProps(CourseConfigType.fsaHealth)
    return { props: response }
}) satisfies GetStaticProps<SplashPageProps>

// MUST be named SplashPageExport
const SplashPageExport = (props: SplashPageProps): ReactElement => {
    return (
        <>
            {/* Title and description come from the DefaultSeo in _app; this
                exists so the homepage has an explicit canonical (both the apex
                and www hosts serve it). */}
            <PageSeo
                title={ACTUARY_SITE_TITLE}
                description={ACTUARY_SITE_DESCRIPTION}
                canonicalPath={UiLayoutConstant.SPLASH_PAGE}
            />
            <SplashPage {...props} />
        </>
    )
}

SplashPageExport.isStatic = true

export default SplashPageExport
